import React from 'react';
import axios from 'axios';

const ExportButtons = ({ token, filters }) => {
    const handleExport = async (format) => {
        try {
            const params = new URLSearchParams();
            if (filters.dateRange !== 'all') params.append('days', filters.dateRange);
            if (filters.commune !== 'all') params.append('commune', filters.commune);
            
            const response = await axios.get(`https://survey.legbasoft.com/api/dashboard/export/${format}?${params}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: format === 'excel' ? 'arraybuffer' : 'blob'
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `survey_data.${format === 'excel' ? 'xlsx' : 'csv'}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Export error:', error);
            alert('Export failed. Please try again.');
        }
    };
    
    return (
        <div style={{ display: 'flex', gap: '10px' }}>
            <button 
                onClick={() => handleExport('csv')}
                style={{
                    padding: '8px 16px',
                    background: '#27ae60',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                }}
            >
                📄 Export CSV
            </button>
            <button 
                onClick={() => handleExport('excel')}
                style={{
                    padding: '8px 16px',
                    background: '#2ecc71',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer'
                }}
            >
                📊 Export Excel
            </button>
        </div>
    );
};

export default ExportButtons;